import styled from "@emotion/styled"

const ArticleAsideBlogPostWrapper = styled.div`
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  ${({ theme }) => theme.breakpoints.down("md")} {
    padding-bottom: 21px;
  }

  ${({ theme }) => theme.breakpoints.between("md", "lg")} {
    display: flex;
    gap: 30px;
    padding-bottom: 21px;
  }

  ${({ theme }) => theme.breakpoints.down("lg")} {
  }

  ${({ theme }) => theme.breakpoints.between("lg", "xl")} {
    padding-bottom: 26px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    padding-bottom: 32px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    padding-bottom: 40px;
  }
`

export default ArticleAsideBlogPostWrapper
